export let w = 800;
export let h = 800;
export let rw = w;      // Real Width
export let rh = h;      // Real Height

export function init(element, _w, _h) {
    // Set size
    w = _w;
    h = _h;

    // Calc canvas size
    const ratio = window.devicePixelRatio || 1;
    const rect = element.getBoundingClientRect();
    rw = rect.width * ratio;
    rh = rect.height * ratio;

    // Max canvas size is 4096
    while (Math.min(rw, rh) > 4096) {
        rw /= 2
        rh /= 2
    }
    rw = Math.trunc(rw);
    rh = Math.trunc(rh);

    return {w: rw, h: rh}
}

export function rateX() {
    return rw / w;
}
export function rateY() {
    return rh / h;
}
